import React from 'react';
import styled from 'styled-components';

import { Form, Typography, Input, Row, Col, Alert } from 'antd';
import { MoneyInput } from '@yuhuinc/ui-library';
import { getTranslatedString } from 'helpers/i18n';
import { PaysafeFields } from './PaysafeFields';

const { Title } = Typography;

const StyledForm = styled(Form)`
  padding: 24px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
`;

const StyledCol = styled(Col)`
  margin-top: 12px;
`;

const requiredField = {
  required: true,
  message: getTranslatedString('required'),
};

const requiredAndMinField = {
  required: true,
  min: 5,
  type: 'number',
  message: 'A minimum of $5.00 is required to process this transaction.',
};

const PaymentBlock = ({
  form,
  setPaysafeInstance,
  cardNumberError,
  cvvError,
  expiryDateError,
  setCardNumberError,
  setCvvError,
  setExpiryDateError,
  paymentDisabled,
  paymentHold,
}) => {
  const initialValues = {};

  const title = paymentHold ? 'Payment hold details' : 'Payment card details';
  return (
    <StyledForm form={form} initialValues={initialValues} layout="vertical">
      <Title level={5} style={{ margin: 0 }}>
        {title}
      </Title>
      {paymentHold && (
        <Alert
          message="This transaction will place a hold on your card for 7 days and it will not be charged unless approved."
          type="info"
          showIcon
        />
      )}
      <Row gutter={16}>
        <StyledCol md={12} sm={24}>
          <Form.Item name="payment_amount" label="Payment amount" rules={[requiredAndMinField]}>
            <MoneyInput disabled={paymentDisabled} />
          </Form.Item>
        </StyledCol>
        <StyledCol md={12} sm={24}>
          <Form.Item name="name" label="Name on card" rules={[requiredField]}>
            <Input />
          </Form.Item>
        </StyledCol>
        <PaysafeFields
          setPaysafeInstance={setPaysafeInstance}
          cardNumberError={cardNumberError}
          cvvError={cvvError}
          expiryDateError={expiryDateError}
          setCardNumberError={setCardNumberError}
          setCvvError={setCvvError}
          setExpiryDateError={setExpiryDateError}
        />

        <StyledCol md={12} sm={24}>
          <Form.Item name="postal_code" label="Postal code" rules={[requiredField]}>
            <Input />
          </Form.Item>
        </StyledCol>
      </Row>
    </StyledForm>
  );
};

export default PaymentBlock;
